import "./solutionCard.css";

export const SolutionCard = ({ image, numbers, description, position }) => {
  return (
    <div className={`solution-card ${position}`}>
          <img src={image} alt={image}/>
          <h1>{numbers}</h1>
          <p className="body1">{description}</p>
    </div>
  );
};
